import { render, staticRenderFns } from "./ScreenFull.vue?vue&type=template&id=572362ec&scoped=true"
import script from "./ScreenFull.vue?vue&type=script&lang=js"
export * from "./ScreenFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572362ec",
  null
  
)

export default component.exports